import { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useGetComputedRoute } from "~/OnboardingApp/features/Nav/hooks";

interface Props {
  children: ReactNode;
}

export const ComputedStepRedirecter: FC<Props> = ({ children }) => {
  const location = useLocation();
  const currentRoute = location.pathname;
  const computedStep = useGetComputedRoute();

  if (computedStep.route && computedStep.route != currentRoute) {
    const nextRoute = computedStep.route;

    return <Navigate to={nextRoute} state={location.state} />;
  }

  return <>{children}</>;
};
